import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ApiError } from "../api/client";
import { SocialLoginButtons } from "./SocialLoginButtons";

export default function RegisterForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { registerWithCredentials } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Las contraseñas deben coincidir");
      return;
    }

    if (password.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres");
      return;
    }

    setIsSubmitting(true);
    try {
      await registerWithCredentials(email.trim(), password);
      navigate("/dashboard/configuracion");
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
          ? err.message
          : "No se pudo crear la cuenta";
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-grid" style={{ gap: "1.5rem" }}>
      <form className="form-grid" style={{ gap: "1rem" }} onSubmit={handleSubmit} noValidate>
        {error && (
          <div className="empty-state" style={{ borderColor: "rgba(220, 38, 38, 0.4)", color: "#b91c1c" }}>
            {error}
          </div>
        )}
        <label style={{ fontWeight: 600, color: "#334155" }}>
          Email
          <input
            className="input"
            type="email"
            placeholder="familia@ahorrayrespira.com"
            value={email}
            onChange={event => setEmail(event.target.value)}
            required
            autoComplete="email"
          />
        </label>
        <div className="form-grid form-grid-2">
          <label style={{ fontWeight: 600, color: "#334155" }}>
            Contraseña
            <input
              className="input"
              type="password"
              placeholder="Mínimo 8 caracteres"
              value={password}
              onChange={event => setPassword(event.target.value)}
              required
              autoComplete="new-password"
            />
          </label>
          <label style={{ fontWeight: 600, color: "#334155" }}>
            Confirmar
            <input
              className="input"
              type="password"
              placeholder="Repite la contraseña"
              value={confirmPassword}
              onChange={event => setConfirmPassword(event.target.value)}
              required
              autoComplete="new-password"
            />
          </label>
        </div>
        <button type="submit" className="btn btn-primary" disabled={isSubmitting} style={{ justifyContent: "center" }}>
          {isSubmitting ? "Creando cuenta..." : "Crea tu cuenta gratis"}
        </button>
      </form>
      <div>
        <p className="section-subtitle" style={{ marginBottom: "1rem" }}>
          O regístrate usando tus cuentas favoritas:
        </p>
        <SocialLoginButtons />
      </div>
    </div>
  );
}
